import axios from "axios";
import { useQuery } from "react-query";

export const useAggrMetricsAcrossTimeAndDimension = ({
  contentType,
  dateValuePath,
  // Optional { [contentType]: { valuePath, dateAsString } } — buckets each doc
  // on its own date field via a BE $switch. Use instead of dateValuePath when
  // the collection spans content types with different (and string vs Date) dates.
  dateValuePathByContentType,
  // Explicit { from, to } window to zero-fill the timeline across. Required
  // alongside dateValuePathByContentType if you want empty intervals plotted —
  // the per-CT path can't derive its own range (see the BE service).
  timelineRange,
  dimensionValuePath,
  interval = "day",
  findQuery,
  cyclical = false,
  activeFilters = [],
  includeNullDimensions,
  queryOptions = {},
}) => {
  const body = {
    contentType,
    dateValuePath,
    dateValuePathByContentType,
    timelineRange,
    dimensionValuePath,
    interval,
    findQuery,
    cyclical,
    activeFilters,
    ...(includeNullDimensions !== undefined && { includeNullDimensions }),
  };

  const endpoint = `/api/insightMatrix/aggrMetricsAcrossTimeAndDimension`;

  // Keyed on the request alone — see useAggrMetricsAcrossDimensions.
  return useQuery({
    queryKey: ["useAggrMetricsAcrossTimeAndDimension", body],
    queryFn: () =>
      axios
        .post(endpoint, body, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((data) => data.data),
    // Only enable query if required fields are present
    enabled:
      Boolean(contentType && (dateValuePath || dateValuePathByContentType)) &&
      (queryOptions.enabled !== false),
    ...queryOptions,
  });
};

